// /boards 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 3개 + 유형 select 를 이 배열 하나로 대체한다.
// field 키 / operator / select 옵션 값은 기존 코드와 100% 동일하게 유지한다.

import type { SearchFieldConfig } from "components/list";

export const boardsSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID", type: "text", operator: "contains", width: 140 },
  { name: "name", label: "이름", type: "text", operator: "contains", width: 200 },
  {
    name: "boardKind",
    label: "유형",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "NORMAL", label: "이야기" },
      { value: "ALBUM", label: "포토앨범" },
      { value: "AGENDA", label: "알림장" },
      { value: "MEAL", label: "식단표" },
    ],
  },
  { name: "centerId", label: "센터ID", type: "text", operator: "contains", width: 200 },
];
